<section class="ftco-section ftco-property-details" *ngIf="subscriptionInfo">
    <div class="menu-tab mt-sm-3 mt-xs-3">
        <div class="row">
            <div class="col-md-12 pills">
                <div class="card" *ngIf="subscriptionInfo.hasSubscription && !subscriptionInfo.result">
                    <div class="card-body">
                        <h5 class="card-text text-center alert alert-danger">
                            You have reached your limit. You
                            cannot submit more property. If you want to submit
                            more property, please <a class="contact-link" href="contact">contact us</a>.
                        </h5>
                    </div>
                </div>

                <div class="card mt-3" *ngIf="!subscriptionInfo.hasSubscription">
                    <div class="card-body">
                        <h5 class="card-text text-center alert alert-danger">
                            You cannot submit property. Please subscribe to submit property.
                        </h5>
                        <div class="text-center">
                        <a href="subscription-owner-plan" class="btn btn-primary">Subscribe Now</a>
                        </div>
                    </div>
                </div>
                <!-- <button (click)="oprenTerm()"></button> -->
                <div class="bd-example bd-example-tabs mt-3"
                    *ngIf="!isAllStepDone && (subscriptionInfo.hasSubscription && subscriptionInfo.result)">
                    <div class="d-flex modern-tabs">
                        <ul class="modern-tab-list">
                            <li class="modern-tab-item mb-2"
                                [ngClass]="{'active': activeTab === 'property_details', 'disabled': currentStep < 1}">
                                <a href="javascript:void(0)" (click)="onMenu('property_details')">
                                    Property Details
                                </a>
                            </li>
                            <li class="modern-tab-item"
                                [ngClass]="{'active': activeTab === 'locality_details', 'disabled': currentStep < 2}">
                                <a href="javascript:void(0)" (click)="onMenu('locality_details')">
                                    Unit Information
                                </a>
                            </li>
                            <li class="modern-tab-item"
                                [ngClass]="{'active': activeTab === 'resale_details', 'disabled': currentStep < 3}">
                                <a href="javascript:void(0)" (click)="onMenu('resale_details')">
                                    Price Details
                                </a>
                            </li>
                            <li class="modern-tab-item" [ngClass]="{'active': activeTab === 'amenities', 'disabled': currentStep < 4}">
                                <a href="javascript:void(0)" (click)="onMenu('amenities')">
                                    Amenities
                                </a>
                            </li>
                            <li class="modern-tab-item" [ngClass]="{'active': activeTab === 'gallary', 'disabled': currentStep < 5}">
                                <a href="javascript:void(0)" (click)="onMenu('gallary')">
                                    Gallery
                                </a>
                            </li>
                        </ul>
                
                    </div>

                    <!-- Property Details -->
                    <div class="tab-content modern-property-form" id="pills-tabContent">
                        <div class="div-pile fade show" role="tabpanel"
                            *ngIf="activeTab == 'property_details'">
                            <div class="row">
                                <div class="property_details">
                                    <form class="p_details"
                                        [formGroup]="proertydetailsForm"
                                        method="POST">
                                        <div class="row">
                                            <div class="row mt-2">
                                                <div class="col-12">
                                                    <div class="form-group Walls">
                                                        <div class="wall_radio custom-radio-group">
                                                            <input type="radio" id="r_type_2" class="custom-radio" formControlName="selling_type" value="2" />
                                                            <label for="r_type_2">Rent</label>
                                        
                                                            <input type="radio" id="r_type_1" class="custom-radio" formControlName="selling_type" value="1" />
                                                            <label for="r_type_1">Sell</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row"
                                                *ngIf="proertydetailsForm.value.selling_type === '1'">
                                                <div class="col-12">
                                                    <div
                                                        class="form-group Walls Walls-2"
                                                        [class.has-error]="proertydetailssubmit && !proertydetailsForm.get('property_construction_type').valid">
                                                        <div class="wall_radio custom-radio-group">
                                                            <input type="radio" id="ready" class="custom-radio" formControlName="property_construction_type" value="1" />
                                                            <label for="ready">Ready to Move In</label>
                                                        
                                                            <input type="radio" id="under" class="custom-radio" formControlName="property_construction_type" value="2" />
                                                            <label for="under">Off plan / Under Construction</label>
                                                        </div>
                                                    </div>
                                                    <div style="color: red;"
                                                        class="mt-1"
                                                        *ngIf="submit && proertydetailsForm.get('property_construction_type').hasError('required')">
                                                        Please select Property
                                                        Type.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row"
                                                *ngIf="proertydetailsForm.value.selling_type === '1' && proertydetailsForm.value.property_construction_type === '2'">
                                                <div class="col-6">
                                                    <div
                                                        class="form-group date">
                                                        <label
                                                            for="project_name">Project
                                                            Name</label>
                                                        <input type="text"
                                                            id="project_name"
                                                            class="form-control box_1"
                                                            placeholder
                                                            formControlName="project_name"
                                                            [class.is-invalid]="proertydetailsForm.value.property_construction_type === '2' && proertydetailsForm.value.project_name == '' && this.proertydetailssubmit==true">
                                                        <div
                                                            class="invalid-feedback">
                                                            Project Name is
                                                            required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="form-group date">
                                                    <label
                                                        for="tagline" class="lable-header">Tagline</label>
                                                    <input type="text"
                                                        id="tagline"
                                                        class="form-control box_1"
                                                        placeholder
                                                        formControlName="tagline"
                                                        [class.is-invalid]="proertydetailsForm.value.tagline == '' && this.proertydetailssubmit==true">
                                                    <div
                                                        class="invalid-feedback">
                                                        Tagline is required.
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="row"
                                                *ngIf="proertydetailsForm.value.property_construction_type === '2'">
                                                <div class="col-6">
                                                    <div class="form-group date">
                                                        <label for="handover_date">Handover Date</label>
                                                        <input type="date" id="handover_date" class="form-control box_1"
                                                            placeholder="" formControlName="handover_date"
                                                            [class.is-invalid]="proertydetailsForm.value.property_construction_type === '2' && proertydetailsForm.value.handover_date == '' && this.proertydetailssubmit==true">
                                                        <div class="invalid-feedback">
                                                            Handover Date is required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->

                                            <div class="row"
                                                *ngIf="proertydetailsForm.value.selling_type === '1' && proertydetailsForm.value.property_construction_type === '2'">
                                                <div class="col-6">
                                                    <label
                                                        for="handover_date">Handover
                                                        Date</label>
                                                    <div class="row">
                                                        <div class="col-6"
                                                            [class.open]="isDropdown1"
                                                            (document:click)="onDocument($event)">
                                                            <div
                                                                class="form-control box_1">
                                                                <div
                                                                    class="form-field">
                                                                    <div
                                                                        class="select-wrap">
                                                                        <div
                                                                            class="custom-dropdown">
                                                                            <div
                                                                                class="selected-option"
                                                                                (click)="toggleHandover1()">
                                                                                {{
                                                                                selectedQuarterly
                                                                                ||
                                                                                'Select a quarter'
                                                                                }}
                                                                                <span
                                                                                    class="fa fa-chevron-down mr-1"></span>
                                                                            </div>
                                                                            <div
                                                                                class="options"
                                                                                *ngIf="isDropdown1">
                                                                                <div
                                                                                    *ngFor="let quarterly of quarterlyOptions; let i=index"
                                                                                    (click)="selectQuarterly(quarterly, i + 1)">
                                                                                    {{
                                                                                    quarterly
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-6"
                                                            [class.open]="isDropdown2"
                                                            (document:click)="onDocumentYear($event)">
                                                            <div
                                                                class="form-control box_2">
                                                                <div
                                                                    class="form-field">
                                                                    <div
                                                                        class="select-wrap">
                                                                        <div
                                                                            class="custom-dropdown custom-dropdown-year">
                                                                            <div
                                                                                class="selected-option"
                                                                                (click)="toggleHandover2()">
                                                                                {{
                                                                                selectedYear
                                                                                ||
                                                                                'Select a year'
                                                                                }}
                                                                                <span
                                                                                    class="fa fa-chevron-down mr-1"></span>
                                                                            </div>
                                                                            <div
                                                                                class="options"
                                                                                *ngIf="isDropdown2">
                                                                                <div
                                                                                    *ngFor="let year of yearOptions; let i=index"
                                                                                    (click)="selectYear(year, i + 1)">
                                                                                    {{
                                                                                    year
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="color: red;"
                                                        class="mt-1"
                                                        *ngIf="proertydetailssubmit && (!selectedQuarterly || !selectedYear)">
                                                        Please select Handover
                                                        Date.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-6"
                                                    [class.open]="isDropdownOpen"
                                                    (document:click)="onDocumentClick($event)">
                                                    <label class="lable-header">Property Type</label>
                                                    <div
                                                        class="form-control box_1">
                                                        <div class="form-field">
                                                            <div
                                                                class="select-wrap">
                                                                <div
                                                                    class="custom-dropdown type-dropdown">
                                                                    <div
                                                                        class="selected-option"
                                                                        (click)="toggleDropdown()">
                                                                        {{
                                                                        selectedOption
                                                                        ||
                                                                        'Select an option'
                                                                        }}
                                                                        <span
                                                                            class="fa fa-chevron-down mr-1"></span>
                                                                    </div>
                                                                    <div
                                                                        class="options"
                                                                        *ngIf="isDropdownOpen">
                                                                        <div
                                                                            *ngFor="let option of propertyTypes; let i=index"
                                                                            (click)="selectOption(option, i + 1)">
                                                                            {{
                                                                            option
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="color: red;"
                                                        class="mt-1"
                                                        *ngIf="proertydetailssubmit && !selectedOption">
                                                        Please select Property
                                                        Type.
                                                    </div>

                                                    <div *ngIf="showOthersCard">

                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div
                                                                    class="form-group">
                                                                    <label>Other
                                                                        Property
                                                                        type</label>
                                                                    <input
                                                                        type="text"
                                                                        id="other_property_type"
                                                                        class="form-control box_1"
                                                                        placeholder
                                                                        formControlName="other_property_type"
                                                                        [class.is-invalid]="proertydetailsForm.get('other_property_type') && !proertydetailsForm.get('other_property_type').valid && proertydetailssubmit==true">

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- Bedroom Dropdown -->
                                            <div class="row mt-2">
                                                <div class="col-6"
                                                    [class.open]="isBedroomDropdownOpen"
                                                    (document:click)="onBedroomDocumentClick($event)">
                                                    <label class="lable-header">No. of
                                                        Bedrooms</label>
                                                    <div
                                                        class="form-control box_1">
                                                        <div class="form-field">
                                                            <div
                                                                class="select-wrap">
                                                                <div
                                                                    class="icon"></div>
                                                                <div
                                                                    class="custom-dropdown bedroom-dropdown">
                                                                    <div
                                                                        class="selected-option"
                                                                        (click)="toggleBedroomDropdown()">
                                                                        {{
                                                                        bedroomSelectedOption
                                                                        ||
                                                                        'Select
                                                                        an
                                                                        option'
                                                                        }}<span
                                                                            class="fa fa-chevron-down mr-1"></span>
                                                                    </div>
                                                                    <div
                                                                        class="options"
                                                                        *ngIf="isBedroomDropdownOpen">
                                                                        <div
                                                                            *ngFor="let option of numberofbedroom"
                                                                            (click)="selectBedroomOption(option)"
                                                                            [ngClass]="bedroomSelectedOption == option ? 'selected-option-dropdown' : ''">
                                                                            {{
                                                                            option
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="color: red;"
                                                        class="mt-1"
                                                        *ngIf="proertydetailssubmit==true && !bedroomSelectedOption">
                                                        Please select No. of
                                                        Bedrooms.
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Bathroom Dropdown -->
                                            <div class="row mt-2">
                                                <div class="col-6"
                                                    [class.open]="isBathroomDropdownOpen"
                                                    (document:click)="onBathroomDocumentClick($event)">
                                                    <label class="lable-header">No. of
                                                        Bathrooms</label>
                                                    <div
                                                        class="form-control box_1">
                                                        <div class="form-field">
                                                            <div
                                                                class="select-wrap">
                                                                <div
                                                                    class="icon"></div>
                                                                <div
                                                                    class="custom-dropdown bathroom-dropdown">
                                                                    <div
                                                                        class="selected-option"
                                                                        (click)="toggleBathroomDropdown()">
                                                                        {{
                                                                        bathroomSelectedOption
                                                                        ||
                                                                        'Select
                                                                        an
                                                                        option'
                                                                        }}<span
                                                                            class="fa fa-chevron-down mr-1"></span>
                                                                    </div>
                                                                    <div
                                                                        class="options"
                                                                        *ngIf="isBathroomDropdownOpen">
                                                                        <div
                                                                            *ngFor="let option of numberOfBathrooms"
                                                                            (click)="selectBathroomOption(option)"
                                                                            [ngClass]="bathroomSelectedOption == option ? 'selected-option-dropdown' : ''">
                                                                            {{
                                                                            option
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style="color: red;"
                                                        class="mt-1"
                                                        *ngIf="proertydetailssubmit==true && !bathroomSelectedOption">
                                                        Please select No. of
                                                        Bathrooms.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-2">
                                                <div class="col-12">
                                                    <label class="lable-header">Property
                                                        Features</label>
                                                    <div class="row"
                                                        *ngIf="proertydetailsForm.value.selling_type === '2' || (proertydetailsForm.value.selling_type === '1' && proertydetailsForm.value.property_construction_type === '1')">
                                                        <p
                                                            class="col-12 col-md-3 "
                                                            formArrayName="property_features"
                                                            *ngFor="let order of featuresFormArray.controls; let i = index">
                                                            <input
                                                                type="checkbox"
                                                                id="property_features_{{i}}"
                                                                class="modern-checkbox cursor"
                                                                [formControlName]="i">
                                                            <label
                                                                class="cursor modern-checkbox-label"
                                                                for="property_features_{{i}}">{{featuresData[i].name}}</label>
                                                        </p>
                                                    </div>

                                                    <div class="row"
                                                        *ngIf="proertydetailsForm.value.selling_type === '1' && proertydetailsForm.value.property_construction_type === '2'">
                                                        <p class="col-3"
                                                            formArrayName="property_features_2"
                                                            *ngFor="let order of featuresFormArray2.controls; let i = index">
                                                            <input
                                                                type="checkbox"
                                                                id="off_plan_property_features_{{i}}"
                                                                class="modern-checkbox cursor"
                                                                [formControlName]="i">
                                                            <label
                                                                class="cursor modern-checkbox-label"
                                                                for="off_plan_property_features_{{i}}">{{featuresDataOffPlan[i].name}}</label>
                                                        </p>
                                                    </div>

                                                    <div style="color: red;"
                                                        *ngIf="proertydetailssubmit==true && proertydetailsForm && !proertydetailsForm.get('property_features').valid ">
                                                        Please enter a valid
                                                        Property Feature.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="lable-header">Size (sqft)</label>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <input type="text"
                                                                id="plot_area"
                                                                class="form-control box_1"
                                                                placeholder="Built up"
                                                                formControlName="plot_area"
                                                                [class.is-invalid]="!proertydetailsForm.get('plot_area').valid && proertydetailssubmit==true">
                                                        </div>

                                                        <div class="col-6"
                                                            *ngIf="selected_property_type_id == 2 || selected_property_type_id == 3">
                                                            <input type="text"
                                                                id="plot_size"
                                                                class="form-control box_1"
                                                                placeholder="Plot size"
                                                                formControlName="plot_size"
                                                                [class.is-invalid]="!proertydetailsForm.get('plot_size').valid && proertydetailssubmit==true">
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="invalid-feedback">
                                                        Size is required.
                                                    </div>

                                                </div>
                                            </div>

                                            <!-- <div class="row mt-2">
                                                <div class="col-12">
                                                    <div class="form-group description">
                                                        <label>Description</label>
                                                        <textarea id="description"
                                                            class="form-control box_1"
                                                            placeholder="Write a few lines about your Property."
                                                            formControlName="description"></textarea>
                                                        <div class="invalid-feedback">
                                                            Description is required.
                                                        </div><br>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="row mt-2">
                                                <div class="col-3">
                                                    <div class="form-group date">
                                                        <label
                                                            for="goverment_fee" class="lable-header">Goverment Fee</label>
                                                        <input type="number"
                                                            id="goverment_fee"
                                                            class="form-control box_1"
                                                            formControlName="goverment_fee"
                                                            [class.is-invalid]="proertydetailsForm.value.goverment_fee == '' && this.proertydetailssubmit==true">
                                                        <div
                                                            class="invalid-feedback">
                                                            Goverment Fee is required.
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
    
                                                <!-- <div class="row mt-2">
                                                <div class="col-6">
                                                    <div class="form-group date">
                                                        <label
                                                            for="delivery_date" class="lable-header">Delivery Date</label>
                                                        <input type="date"
                                                            id="delivery_date"
                                                            class="form-control box_1"
                                                            formControlName="delivery_date"
                                                            [class.is-invalid]="proertydetailsForm.value.delivery_date == '' && this.proertydetailssubmit==true">
                                                        <div
                                                            class="invalid-feedback">
                                                            Delivery Date is required.
                                                        </div>
                                                    </div>
                                                </div>
                                                </div> -->
                                            <div class="row mt-2">
                                                <div class="col-12">
                                                    <div
                                                        class="form-group description">
                                                        <label class="lable-header">Description</label>

                                                        <div
                                                            class="NgxEditor__Wrapper">
                                                            <ngx-editor-menu
                                                                [editor]="editor">
                                                            </ngx-editor-menu>
                                                            <ngx-editor
                                                                [editor]="editor"
                                                                [ngModelOptions]="{standalone: true}"
                                                                [(ngModel)]="html"
                                                                [disabled]="false"
                                                                [placeholder]="'Type here...'"></ngx-editor>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <div class="col-3">
                                                    <div class="form-group">
                                                        <button
                                                            class="btn btn-primary save1"
                                                            (click)="onSubmitproperty_details()">Save
                                                            &
                                                            Continue</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>

                        <!-- Locality Details -->
                        <div class="div-pile fade"
                            [ngClass]="activeTab == 'locality_details' ? 'show' : ''"
                            role="tabpanel" *ngIf="activeTab == 'locality_details'">
                            <div class="row">
                                <div class="locality">
                                    <form class="locality"
                                        [formGroup]="localityForm"
                                        method="POST">
                                        <ng-container
                                            *ngIf="proertydetailsForm.value.selling_type == '1'">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div
                                                        class="form-group ownership">
                                                        <label
                                                            class="ownership">Ownership</label>
                                                        <div
                                                            class="ownership_radio">

                                                            <input
                                                                class="cursor"
                                                                type="radio"
                                                                value="1"
                                                                formControlName="ownership_type">
                                                            FreeHold
                                                            <input
                                                                class="cursor"
                                                                type="radio"
                                                                value="2"
                                                                formControlName="ownership_type">
                                                            LeaseHold

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div class="row">
                                            <div class="col-6 mb-2">
                                                <div class=" form-group">
                                                    <label
                                                        *ngIf="proertydetailsForm.value.property_construction_type === '1'">Upload
                                                        {{localityForm.value.ownership_type
                                                        == '2' ? 'Lease' :
                                                        'Title'}}
                                                        Deed</label>
                                                    <label
                                                        *ngIf="proertydetailsForm.value.property_construction_type === '2'">Upload
                                                        Sale & Purchase
                                                        Agreement
                                                        (SPA)</label><br>
                                                    <input style="display: none"
                                                        type="file"
                                                        #deedFileInput
                                                        (change)="onFileChange($event)"
                                                        accept="image/*, application/pdf"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="deedFileInput.click()">Attach</button>
                                                    <div
                                                        *ngIf="deedImages.length > 0">
                                                        <label>Image</label>
                                                        <div class="row mt-2">
                                                            <ng-container
                                                                *ngFor="let image of deedImages; let i = index">
                                                                <div
                                                                    class="col-4">
                                                                    <div
                                                                        class="row">
                                                                        <p
                                                                            class="file_name"
                                                                            *ngIf="!image.fromAPI && !image.isImage">{{image.file.name}}</p>
                                                                        <p
                                                                            class="file_name pointer"
                                                                            *ngIf="image.fromAPI && !image.isImage"
                                                                            (click)="openImage(image.result)">{{image.result}}</p>
                                                                        <img
                                                                            [src]="shared.getImageURL(image.result)"
                                                                            *ngIf="image.fromAPI && image.isImage"
                                                                            alt="Image"
                                                                            width="150"
                                                                            height="150" />
                                                                        <img
                                                                            [src]="image.result"
                                                                            *ngIf="!image.fromAPI && image.isImage"
                                                                            alt="Image"
                                                                            width="150"
                                                                            height="150" />
                                                                        <div
                                                                            class="delete-div mt-1">
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-danger"
                                                                                style="line-height: 0px;"
                                                                                (click)="deleteDeedImage(i)"><i
                                                                                    style="font-size:18px"
                                                                                    class="fa">&#xf1f8;</i><br>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <span class="mb-1"
                                            *ngIf="is_step2_submit && (deedImages.length == 0)"
                                            style="color: #dc3545 !important;">Please
                                            ensure you upload at least one
                                            image of
                                            {{proertydetailsForm.value.property_construction_type
                                            === '2' ?
                                            'Sale & Purchase Agreement(SPA)' :
                                            (localityForm.value.ownership_type
                                            == '2'
                                            ? 'Lease' : 'Title') + ' Deed'}}.
                                            <br></span>
                                        <span>*{{proertydetailsForm.value.property_construction_type
                                            === '2' ? 'SPA' :
                                            (localityForm.value.ownership_type
                                            == '2' ? 'Lease' : 'Title') +
                                            ' Deed'}}
                                            is for Direkt.ae's verification
                                            purpose only.</span>

                                        <div class="row"
                                            *ngIf="proertydetailsForm.value.property_construction_type === '2'">
                                            <div class="col-6">
                                                <div class=" form-group">
                                                    <label>Upload Floor
                                                        Plan</label><br>
                                                    <input style="display: none"
                                                        type="file"
                                                        #floorFileInput
                                                        (change)="onFloorFileChange($event)"
                                                        accept="application/pdf"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="floorFileInput.click()">Attach
                                                        PDF</button>
                                                    <div
                                                        *ngIf="floorImages.length > 0">
                                                        <div class="row mt-2">
                                                            <ng-container
                                                                *ngFor="let image of floorImages; let i = index">
                                                                <div
                                                                    class="col-4">
                                                                    <div
                                                                        class="row">
                                                                        <p
                                                                            class="file_name pointer"
                                                                            *ngIf="image.fromAPI && !image.isImage"
                                                                            (click)="openImage(image.result)">{{image.result}}</p>
                                                                        <p
                                                                            class="file_name"
                                                                            *ngIf="!image.isImage && image.file">{{image.file.name}}</p>
                                                                        <div
                                                                            class="delete-div mt-1">
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-danger"
                                                                                style="line-height: 0px;"
                                                                                (click)="deleteFloorImage(i)"><i
                                                                                    style="font-size:18px"
                                                                                    class="fa">&#xf1f8;</i><br>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="mb-1"
                                            *ngIf="is_step2_submit && proertydetailsForm.value.property_construction_type === '2' && floorImages.length == 0"
                                            style="color: #dc3545 !important;">Please
                                            ensure you upload pdf of floor
                                            plan.</span>

                                        <div class="row">
                                            <div class="col-6">
                                                <div class=" form-group">
                                                    <label>Address as per
                                                        {{proertydetailsForm.value.property_construction_type
                                                        === '2' ?
                                                        'SPA' :
                                                        (localityForm.value.ownership_type
                                                        == '2' ? 'Lease' :
                                                        'Title') +
                                                        ' Deed'}}</label><br>
                                                    <textarea
                                                        class="form-control box_1"
                                                        id="address"
                                                        name="address"
                                                        formControlName="address"
                                                        [class.is-invalid]="localityForm.get('address')!.invalid && landmarksubmit"
                                                        (input)="onTextareaChange($event)"></textarea>
                                                    <ng-container
                                                        *ngIf="locationOptions.length > 0">
                                                        <div
                                                            [class.open]="isAddressDropdownOpen"
                                                            (document:click)="onAddressDocumentClick($event)">
                                                            <div
                                                                class="form-field">
                                                                <div
                                                                    class="select-wrap">
                                                                    <div
                                                                        class="icon"></div>
                                                                    <div
                                                                        class="custom-dropdown address-dropdown">
                                                                        <div
                                                                            class="options"
                                                                            *ngIf="isAddressDropdownOpen">
                                                                            <div
                                                                                *ngFor="let data of locationOptions"
                                                                                (click)="onLocationSelect(data)"
                                                                                [ngClass]="localityForm.value.address == data.label ? 'selected-option-dropdown' : ''">
                                                                                {{
                                                                                data.label
                                                                                }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <div
                                                        class="invalid-feedback">
                                                        Address is required.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6"
                                                [class.open]="isCityDropdownOpen"
                                                (document:click)="onCityDocumentClick($event)">
                                                <label>Emirate</label>
                                                <div class="form-control box_1">
                                                    <div class="form-field">
                                                        <div
                                                            class="select-wrap">
                                                            <div
                                                                class="icon"></div>
                                                            <div
                                                                class="custom-dropdown city-dropdown">
                                                                <div
                                                                    class="selected-option"
                                                                    (click)="toggleCityDropdown()">
                                                                    {{
                                                                    citySelectedOption
                                                                    ?
                                                                    citySelectedOption.city_name
                                                                    || 'Select
                                                                    an
                                                                    option' : ''
                                                                    }}<span
                                                                        class="fa fa-chevron-down mr-1"></span>
                                                                </div>
                                                                <div
                                                                    class="options"
                                                                    *ngIf="isCityDropdownOpen">
                                                                    <div
                                                                        *ngFor="let option of cityOptions"
                                                                        (click)="selectCityOption(option)"
                                                                        [ngClass]="citySelectedOption == option ? 'selected-option-dropdown' : ''">
                                                                        {{
                                                                        option.city_name
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="color: red;"
                                                    class="mt-1"
                                                    *ngIf="landmarksubmit && !citySelectedOption && !citySelectedOption.city_name">
                                                    Please select Emirate.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-2">
                                            <div class="col-6"
                                                [class.open]="isLandmarkDropdownOpen"
                                                (document:click)="onLandmarkDocumentClick($event)">
                                                <label>Location</label>
                                                <div class="form-control box_1">
                                                    <div class="form-field">
                                                        <div
                                                            class="select-wrap">
                                                            <div
                                                                class="icon"></div>
                                                            <div
                                                                class="custom-dropdown landmark-dropdown">
                                                                <div
                                                                    class="selected-option"
                                                                    (click)="toggleLandmarkDropdown()">
                                                                    {{
                                                                    landmarkSelectedOption
                                                                    ?
                                                                    landmarkSelectedOption.landmark_name
                                                                    || 'Select
                                                                    an option' :
                                                                    ''
                                                                    }}<span
                                                                        class="fa fa-chevron-down mr-1"></span>
                                                                </div>
                                                                <div
                                                                    class="options"
                                                                    *ngIf="isLandmarkDropdownOpen">
                                                                    <div><input
                                                                            placeholder="Search Location"
                                                                            (keyup)="searchCity($event)"
                                                                            class="form-control search_location"
                                                                            type="text" /></div>

                                                                    <div
                                                                        *ngFor="let option of landmarkList"
                                                                        (click)="selectLandmarkOption(option)"
                                                                        [ngClass]="landmarkSelectedOption == option ? 'selected-option-dropdown' : ''">
                                                                        {{
                                                                        option.landmark_name
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="color: red;"
                                                    class="mt-1"
                                                    *ngIf="landmarksubmit && !landmarkSelectedOption && !landmarkSelectedOption.landmark_name">
                                                    Please select Location.
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                    <div class="row mt-3">
                                        <div class="col-12">
                                            <div class="form-group submit">
                                                <button
                                                    class="btn btn-primary back"
                                                    (click)="onBack('property_details')">Back</button>

                                                <button
                                                    class="btn btn-primary save"
                                                    (click)="onlandmark_details()">Save
                                                    & Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Resale Details -->
                        <div class="div-pile fade "
                            [ngClass]="activeTab == 'resale_details' ? 'show' : ''"
                            *ngIf="activeTab == 'resale_details'"
                            id="pills-resale-details" role="tabpanel">
                            <div class="row">
                                <div class="resale">
                                    <form class="form-group resale_details"
                                        [formGroup]="resaleForm">
                                        <div class="row">

                                            <div class="row">
                                                <div class="col-12 col-md-4">
                                                    <div class="price">
                                                        <label>
                                                            {{proertydetailsForm.value.selling_type
                                                            == '1' ? 'Expected
                                                            Price' :
                                                            'Expected Rent'}}
                                                        </label>
                                                        <input type="text"
                                                            id="price"
                                                            class="form-control box_1"
                                                            placeholder="Enter Amount in AED"
                                                            formControlName="price"
                                                            [class.is-invalid]="resaleForm.get('price')!.invalid && this.resalesubmit==true">
                                                        <div
                                                            class="invalid-feedback">
                                                            Price is required.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-4" *ngIf="proertydetailsForm.value.selling_type == '2'">
                                                    <div class="form-group similar_units">
                                                        <label>Payment Type</label>
                                                        <div class="modern-radio-group">
                                                            <input type="radio" id="monthly" class="modern-radio" value="1" formControlName="is_payment_type" />
                                                            <label for="monthly">Monthly</label>
                                                
                                                            <input type="radio" id="quarterly" class="modern-radio" value="2" formControlName="is_payment_type" />
                                                            <label for="quarterly">Quarterly</label>
                                                
                                                            <input type="radio" id="yearly" class="modern-radio" value="3" formControlName="is_payment_type" />
                                                            <label for="yearly">Yearly</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12 col-md-4"
                                                    *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                                    <div
                                                        class="form-group date">
                                                        <label>Available
                                                            from</label>
                                                        <input type="date"
                                                            id="available_from"
                                                            class="form-control box_1"
                                                            placeholder
                                                            formControlName="available_from"
                                                            [class.is-invalid]="resaleForm.get('available_from')!.invalid && this.resalesubmit==true">
                                                        <div
                                                            class="invalid-feedback">
                                                            Date is required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-2" *ngIf="proertydetailsForm.value.selling_type == '1'">
                                                <div class="col-12 col-md-8">
                                                    <div class="invalid-feedback">
                                                        Price is required.
                                                    </div>
                                                    <div class="checkbox-group">
                                                        <label class="checkbox-item">
                                                            <input type="checkbox" class="cursor" id="is_price_negotiable" formControlName="is_price_negotiable"
                                                                [class.is-invalid]="resaleForm.get('is_price_negotiable')!.invalid && resalesubmit" />
                                                            Price Negotiable
                                                        </label>
                                            
                                                        <label class="checkbox-item">
                                                            <input type="checkbox" class="cursor" id="is_under_loan" formControlName="is_under_loan"
                                                                [class.is-invalid]="resaleForm.get('is_under_loan')!.invalid && resalesubmit" />
                                                            Mortgaged
                                                        </label>
                                            
                                                        <ng-container *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                                            <label class="checkbox-item">
                                                                <input type="checkbox" class="cursor" id="is_tainted" formControlName="is_tainted"
                                                                    [class.is-invalid]="resaleForm.get('is_tainted')!.invalid && resalesubmit" />
                                                                Rented
                                                            </label>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                    <div class="row mt-3">
                                        <div class="col-12 col-md-8">
                                            <div class="form-group submit buttons-group">
                                                <button
                                                    class="btn btn-primary back"
                                                    (click)="onBack('locality_details')">Back</button>
                                                <button
                                                    class="btn btn-primary save"
                                                    (click)="onresale_details()">Save
                                                    &
                                                    Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Amenities -->
                        <div class="div-pile fade " id="pills-amenities"
                            role="tabpanel"
                            [ngClass]="activeTab == 'amenities' ? 'show' : ''"
                            *ngIf="activeTab == 'amenities'">
                            <div class="row">
                                <div class="amenities">
                                    <form action class="form-group amenities"
                                        [formGroup]="amenitiesForm"
                                        method="POST">

                                        <div class="row">
                                            <div class="col-6">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                             <label>Furnished</label>
                                                             <div class="modern-radio-group">
                                                                <input
                                                                    class="modern-radio cursor"
                                                                     id="furnished_full"
                                                                    type="radio"
                                                                    value="Furnished"
                                                                    formControlName="furnished_type">
                                                                <label for="furnished_full">Furnished</label>
                                                                <input
                                                                    class="modern-radio cursor"
                                                                    id="furnished_semi"
                                                                    type="radio"
                                                                    value="Semi Furnished"
                                                                    formControlName="furnished_type">
                                                                 <label for="furnished_semi">Semi Furnished</label>
                                                                <input
                                                                    class="modern-radio cursor"
                                                                     id="furnished_none"
                                                                    type="radio"
                                                                    value="Unfurnished"
                                                                    formControlName="furnished_type">
                                                                <label for="furnished_none">Unfurnished</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form-group security">
                                                            <label>Balcony</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="balcony_yes" class="modern-radio" value="Yes" formControlName="balcony" />
                                                                <label for="balcony_yes">Yes</label>
                                                
                                                                <input type="radio" id="balcony_no" class="modern-radio" value="No" formControlName="balcony" />
                                                                <label for="balcony_no">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                            <label>Equipped
                                                                Kitchen</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="kitchen_yes" class="modern-radio" value="Yes" formControlName="equipped_kitchen" />
                                                                <label for="kitchen_yes">Yes</label>
                                                            
                                                                <input type="radio" id="kitchen_no" class="modern-radio" value="No" formControlName="equipped_kitchen" />
                                                                <label for="kitchen_no">No</label>
                                                            </div>
                                                            </div>
                                                            </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form-group security">
                                                            <label> No Of
                                                                Parking</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="parking_0" class="modern-radio" value="0" formControlName="no_of_parking" />
                                                                <label for="parking_0">0</label>
                                                    
                                                                <input type="radio" id="parking_1" class="modern-radio" value="1" formControlName="no_of_parking" />
                                                                <label for="parking_1">1</label>
                                                    
                                                                <input type="radio" id="parking_2" class="modern-radio" value="2" formControlName="no_of_parking" />
                                                                <label for="parking_2">2</label>
                                                    
                                                                <input type="radio" id="parking_3" class="modern-radio" value="3+" formControlName="no_of_parking" />
                                                                <label for="parking_3">3+</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                            <label>Maid's
                                                                Room</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="maid_yes" class="modern-radio" value="Yes" formControlName="maids_room" />
                                                                <label for="maid_yes">Yes</label>
                                                            
                                                                <input type="radio" id="maid_no" class="modern-radio" value="No" formControlName="maids_room" />
                                                                <label for="maid_no">No</label>
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-6">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                            <label>Pool</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="pool_yes" class="modern-radio" value="Yes" formControlName="pool" />
                                                                <label for="pool_yes">Yes</label>
                                                            
                                                                <input type="radio" id="pool_no" class="modern-radio" value="No" formControlName="pool" />
                                                                <label for="pool_no">No</label>
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                            <label>Gym</label>
                                                        <div class="modern-radio-group">
                                                            <input type="radio" id="gym_yes" class="modern-radio" value="Yes" formControlName="gym" />
                                                            <label for="gym_yes">Yes</label>
                                                        
                                                            <input type="radio" id="gym_no" class="modern-radio" value="No" formControlName="gym" />
                                                            <label for="gym_no">No</label>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form-group security">
                                                            <label>Pets
                                                                Allowed</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="pets_yes" class="modern-radio" value="Yes" formControlName="pets_allowed" />
                                                                <label for="pets_yes">Yes</label>
                                                        
                                                                <input type="radio" id="pets_no" class="modern-radio" value="No" formControlName="pets_allowed" />
                                                                <label for="pets_no">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                            <label>Children's
                                                                Play
                                                                Area</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="play_yes" class="modern-radio" value="Yes" formControlName="children_play_area" />
                                                                <label for="play_yes">Yes</label>
                                                            
                                                                <input type="radio" id="play_no" class="modern-radio" value="No" formControlName="children_play_area" />
                                                                <label for="play_no">No</label>
                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div
                                                            class="form-group security">
                                                            <label>Walk-in
                                                                Closet</label>
                                                            <div class="modern-radio-group">
                                                                <input type="radio" id="closet_yes" class="modern-radio" value="Yes" formControlName="walk_in_closet" />
                                                                <label for="closet_yes">Yes</label>
                                                            
                                                                <input type="radio" id="closet_no" class="modern-radio" value="No" formControlName="walk_in_closet" />
                                                                <label for="closet_no">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-12">
                                                <div class="form-group submit">

                                                    <button
                                                        class="btn btn-primary back"
                                                        (click)="onBack('resale_details')">Back</button>
                                                    <button
                                                        class="btn btn-primary save"
                                                        (click)="onAnmenities_details()">Save
                                                        &
                                                        Continue</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <!-- Gallary -->
                        <div class="gallary-pills fade" id="pills-gallary"
                            role="tabpanel"
                            [ngClass]="activeTab == 'gallary' ? 'show ' : ''"
                            *ngIf="activeTab == 'gallary'">
                            <div class="row">
                                <div class="gallary">
                                    <form action class="form-group Gallary"
                                        [formGroup]="gallaryForm" method="POST">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col-sm"></div>
                                                <div class="col-sm"></div>
                                                <div class="col-sm">

                                                </div>
                                            </div>
                                        </div>

                                        <!-- Entrance -->
                                        <div>
                                            <h5>
                                                {{proertydetailsForm.value.property_construction_type
                                                == '2' ? "Images" : "Entrance"}}
                                            </h5>
                                            <div class="row gallary-div">
                                                <div class="gallary-content"
                                                    *ngIf="entranceImages.length == 0">
                                                    <i style="font-size:24px"
                                                        class="fa">&#xf030;</i><br>
                                                    <b style="color: black;">Add
                                                        photos to get 5x more
                                                        responses.</b>
                                                </div>
                                                <div
                                                    style="text-align: center;">
                                                    <input type="file"
                                                        style="display: none"
                                                        #entranceFileInput
                                                        (change)="onFileSelected($event,'entrance')"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="entranceFileInput.click()">Add
                                                        Photos</button>
                                                </div>
                                                <div
                                                    *ngIf="entranceImages.length > 0">
                                                    <!-- <div class="row mt-2">
                                                        <ng-container
                                                            *ngFor="let image of entranceImages; let i = index">
                                                            <div class="col-2">
                                                                <div class="row">
                                                                    <img [src]="image" alt="Entrance Image" width="150"
                                                                        height="150" />
                                                                    <div class="delete-div">
                                                                        <button type="button" class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'entrance')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div> -->
                                                    <div class="row mt-2">
                                                        <ng-container
                                                            *ngFor="let image of entranceImages; let i = index">
                                                            <div class="col-2">
                                                                <div
                                                                    class="row">
                                                                    <img
                                                                        [src]="shared.getImageURL(image.result)"
                                                                        *ngIf="image.fromAPI"
                                                                        alt="Entrance Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <img
                                                                        [src]="image.result"
                                                                        *ngIf="image.isImage"
                                                                        alt="Entrance Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <div
                                                                        class="delete-div mt-1">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'entrance')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="isgallaryFormSubmit && entranceImages.length == 0">
                                            <i
                                                style="font-size:15px;color: #dc3545;"
                                                class="fa">&#xf06a;</i><span
                                                class="error-msg ml-1">Please
                                                ensure you upload at least one
                                                {{proertydetailsForm.value.property_construction_type
                                                == '2' ? "Image" :
                                                "image of Entrance"}}.</span>
                                        </div>

                                        <!-- Living Room -->
                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                            <h5>
                                                Living Room
                                            </h5>
                                            <div class="row gallary-div">
                                                <div class="gallary-content"
                                                    *ngIf="livingRoomImages.length == 0">
                                                    <i style="font-size:24px"
                                                        class="fa">&#xf030;</i><br>
                                                    <b style="color: black;">Add
                                                        photos to get 5x more
                                                        responses.</b>
                                                </div>
                                                <div
                                                    style="text-align: center;">
                                                    <input type="file"
                                                        style="display: none"
                                                        #livingRoomFileInput
                                                        (change)="onFileSelected($event,'livingRoom')"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="livingRoomFileInput.click()">Add
                                                        Photos</button>
                                                </div>
                                                <div
                                                    *ngIf="livingRoomImages.length > 0">
                                                    <div class="row mt-2">
                                                        <ng-container
                                                            *ngFor="let image of livingRoomImages; let i = index">
                                                            <div class="col-2">
                                                                <div
                                                                    class="row">
                                                                    <img
                                                                        [src]="shared.getImageURL(image.result)"
                                                                        *ngIf="image.fromAPI"
                                                                        alt="livingRoomImages"
                                                                        width="150"
                                                                        height="150" />
                                                                    <img
                                                                        [src]="image.result"
                                                                        *ngIf="image.isImage"
                                                                        alt="livingRoomImages"
                                                                        width="150"
                                                                        height="150" />
                                                                    <div
                                                                        class="delete-div">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'livingRoom')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1' && isgallaryFormSubmit && isImageError && livingRoomImages.length == 0">
                                            <i
                                                style="font-size:15px;color: #dc3545;"
                                                class="fa">&#xf06a;</i><span
                                                class="error-msg ml-1">Please
                                                ensure you upload at least one
                                                image of
                                                Room.</span>
                                        </div>

                                        <!-- Kitchen -->
                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                            <h5>
                                                Kitchen
                                            </h5>
                                            <div class="row gallary-div">
                                                <div class="gallary-content"
                                                    *ngIf="kitchenImages.length == 0">
                                                    <i style="font-size:24px"
                                                        class="fa">&#xf030;</i><br>
                                                    <b style="color: black;">Add
                                                        photos to get 5x more
                                                        responses.</b>
                                                </div>
                                                <div
                                                    style="text-align: center;">
                                                    <input type="file"
                                                        style="display: none"
                                                        #kitchenFileInput
                                                        (change)="onFileSelected($event,'kitchen')"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="kitchenFileInput.click()">Add
                                                        Photos</button>
                                                </div>
                                                <div
                                                    *ngIf="kitchenImages.length > 0">
                                                    <div class="row mt-2">
                                                        <ng-container
                                                            *ngFor="let image of kitchenImages; let i = index">
                                                            <div class="col-2">
                                                                <div
                                                                    class="row">
                                                                    <img
                                                                        [src]="shared.getImageURL(image.result)"
                                                                        *ngIf="image.fromAPI"
                                                                        alt="kitchen Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <img
                                                                        [src]="image.result"
                                                                        *ngIf="image.isImage"
                                                                        alt="kitchen Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <div
                                                                        class="delete-div">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'kitchen')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1' && isgallaryFormSubmit && isImageError && kitchenImages.length == 0">
                                            <i
                                                style="font-size:15px;color: #dc3545;"
                                                class="fa">&#xf06a;</i><span
                                                class="error-msg ml-1">Please
                                                ensure you upload at least one
                                                image of
                                                Kitchen.</span>
                                        </div>

                                        <!-- Bedroom -->
                                        <ng-container
                                            *ngFor="let _i of bedroomImageCategory.slice(0, bedroomSelectedOption)">
                                            <div
                                                *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                                <h5>
                                                    {{_i.name}}
                                                </h5>
                                                <div class="row gallary-div">
                                                    <div class="gallary-content"
                                                        *ngIf="getBedroomImages(_i.id).length === 0">
                                                        <i
                                                            style="font-size:24px"
                                                            class="fa">&#xf030;</i><br>
                                                        <b
                                                            style="color: black;">Add
                                                            photos to get 5x
                                                            more
                                                            responses.</b>
                                                    </div>
                                                    <div
                                                        style="text-align: center;">
                                                        <input type="file"
                                                            style="display: none"
                                                            [id]="'bedroomFileInput_' + _i.id"
                                                            #washroomFileInput
                                                            (change)="onFileSelected($event,'bedroomImages' + _i.id)"
                                                            multiple />
                                                        <button type="button"
                                                            class="btn btn-primary"
                                                            (click)="washroomFileInput.click()">Add
                                                            Photos</button>
                                                    </div>
                                                    <div
                                                        *ngIf="getBedroomImages(_i.id).length > 0">
                                                        <div class="row mt-2">
                                                            <ng-container
                                                                *ngFor="let image of getBedroomImages(_i.id); let i = index">
                                                                <div
                                                                    class="col-2">
                                                                    <div
                                                                        class="row">
                                                                        <img
                                                                            [src]="shared.getImageURL(image.result)"
                                                                            *ngIf="image.fromAPI"
                                                                            alt="washroom Image"
                                                                            width="150"
                                                                            height="150" />
                                                                        <img
                                                                            [src]="image.result"
                                                                            *ngIf="image.isImage"
                                                                            alt="washroom Image"
                                                                            width="150"
                                                                            height="150" />
                                                                        <div
                                                                            class="delete-div">
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-danger"
                                                                                style="line-height: 0px;"
                                                                                (click)="deleteImage(i,'bedroomImages' + _i.id)"><i
                                                                                    style="font-size:18px"
                                                                                    class="fa">&#xf1f8;</i><br>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                *ngIf="proertydetailsForm.value.property_construction_type == '1' && isgallaryFormSubmit && isImageError && getBedroomImages(_i.id).length == 0">
                                                <i
                                                    style="font-size:15px;color: #dc3545;"
                                                    class="fa">&#xf06a;</i><span
                                                    class="error-msg ml-1">Please
                                                    ensure you upload at least
                                                    one image
                                                    of Bedroom {{_i.id}}.</span>
                                            </div>
                                        </ng-container>

                                        <!-- Washroom -->
                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                            <h5>
                                                Washroom
                                            </h5>
                                            <div class="row gallary-div">
                                                <div class="gallary-content"
                                                    *ngIf="washroomImages.length == 0">
                                                    <i style="font-size:24px"
                                                        class="fa">&#xf030;</i><br>
                                                    <b style="color: black;">Add
                                                        photos to get 5x more
                                                        responses.</b>
                                                </div>
                                                <div
                                                    style="text-align: center;">
                                                    <input type="file"
                                                        style="display: none"
                                                        #washroomFileInput
                                                        (change)="onFileSelected($event,'washroom')"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="washroomFileInput.click()">Add
                                                        Photos</button>
                                                </div>
                                                <div
                                                    *ngIf="washroomImages.length > 0">
                                                    <div class="row mt-2">
                                                        <ng-container
                                                            *ngFor="let image of washroomImages; let i = index">
                                                            <div class="col-2">
                                                                <div
                                                                    class="row">
                                                                    <img
                                                                        [src]="shared.getImageURL(image.result)"
                                                                        *ngIf="image.fromAPI"
                                                                        alt="Washroom Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <img
                                                                        [src]="image.result"
                                                                        *ngIf="image.isImage"
                                                                        alt="Washroom Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <div
                                                                        class="delete-div">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'washroom')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1' && isgallaryFormSubmit && isImageError && washroomImages.length == 0">
                                            <i
                                                style="font-size:15px;color: #dc3545;"
                                                class="fa">&#xf06a;</i><span
                                                class="error-msg ml-1">Please
                                                ensure you upload at least one
                                                image of
                                                Washroom.</span>
                                        </div>

                                        <div
                                            *ngIf="proertydetailsForm.value.property_construction_type == '1'">
                                            <h5 class=" mt-3">
                                                Community(Optional)
                                            </h5>
                                            <div class="row gallary-div">
                                                <div class="gallary-content"
                                                    *ngIf="communityImages.length == 0">
                                                    <i style="font-size:24px"
                                                        class="fa">&#xf030;</i><br>
                                                    <b style="color: black;">Add
                                                        photos to get 5x more
                                                        responses.</b>

                                                </div>
                                                <div
                                                    style="text-align: center;">
                                                    <input type="file"
                                                        style="display: none"
                                                        #communityFileInput
                                                        (change)="onFileSelected($event,'community')"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="communityFileInput.click()">Add
                                                        Photos</button>
                                                </div>
                                                <div
                                                    *ngIf="communityImages.length > 0">
                                                    <div class="row">
                                                        <ng-container
                                                            *ngFor="let image of communityImages; let i = index">
                                                            <div class="col-2">
                                                                <div
                                                                    class="row">
                                                                    <img
                                                                        [src]="shared.getImageURL(image.result)"
                                                                        *ngIf="image.fromAPI"
                                                                        alt="Community Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <img
                                                                        [src]="image.result"
                                                                        *ngIf="image.isImage"
                                                                        alt="Community Image"
                                                                        width="150"
                                                                        height="150" />
                                                                    <div
                                                                        class="delete-div">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'community')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <form action class="form-group Gallary"
                                        [formGroup]="gallaryForm" method="POST">
                                        <div
                                            *ngIf="proertydetailsForm.value.selling_type == '1' && proertydetailsForm.value.property_construction_type == '2'">

                                            <h5>
                                                Brochure
                                            </h5>
                                            <div class="row gallary-div">
                                                <div class="gallary-content"
                                                    *ngIf="brochureImages.length == 0">
                                                    <i style="font-size:24px"
                                                        class="fa">&#xf030;</i><br>
                                                    <b style="color: black;">Add
                                                        PDF to get 5x more
                                                        responses.</b>
                                                </div>
                                                <div
                                                    style="text-align: center;">
                                                    <input type="file"
                                                        style="display: none"
                                                        #brochureFileInput
                                                        (change)="onFileSelected($event,'brochure')"
                                                        accept="application/pdf"
                                                        multiple />
                                                    <button type="button"
                                                        class="btn btn-primary"
                                                        (click)="brochureFileInput.click()">Add
                                                        PDF</button>
                                                </div>
                                                <div
                                                    *ngIf="brochureImages.length > 0">
                                                    <div class="row mt-2">
                                                        <ng-container
                                                            *ngFor="let image of brochureImages; let i = index">
                                                            <div class="col-2">
                                                                <div
                                                                    class="row">
                                                                    <p
                                                                        class="file_name pointer"
                                                                        *ngIf="image.fromAPI && !image.isImage"
                                                                        (click)="openImage(image.result)">{{image.result}}</p>
                                                                    <p
                                                                        class="file_name"
                                                                        *ngIf="!image.fromAPI &&  !image.isImage">{{image.file.name}}</p>
                                                                    <!-- <img [src]="image" alt="Property Image" width="150"
                                                                        height="150" /> -->
                                                                    <div
                                                                        class="delete-div">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger"
                                                                            style="line-height: 0px;"
                                                                            (click)="deleteImage(i,'brochure')"><i
                                                                                style="font-size:18px"
                                                                                class="fa">&#xf1f8;</i><br>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                *ngIf="proertydetailsForm.value.property_construction_type == '2' && isgallaryFormSubmit && isImageError && brochureImages.length == 0">
                                                <i
                                                    style="font-size:15px;color: #dc3545;"
                                                    class="fa">&#xf06a;</i>
                                                <span
                                                    class="error-msg ml-1">Please
                                                    ensure you upload Pdf
                                                    of Brochure.</span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="row mt-2">
                                    <div class="form-group submit ">
                                        <button class="btn btn-primary back"
                                            (click)="onBack('amenities')">Back</button>
                                        <button class="btn btn-primary save"
                                            (click)="onSubmitGallary()">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <ng-container *ngIf="isAllStepDone">
                    <div class="text-center">
                        <i class="fa fa-check-circle tick-icon"
                            style="display: block; margin: 0 auto;"></i>
                        <h2 class="mt-2">
                            Thank You
                        </h2>
                        <p>Your property is submitted, it would be listed after
                            verification.</p>
                        <!-- <div class="row">   -->
                        <button class="col-md-3 mr-2 btn btn-primary submit_btn"
                            (click)="onSubmitPropertyPage()">Submit
                            Another Property</button>
                        <button class="col-md-3 btn btn-primary home_button"
                            (click)="onHomePage()">Back to
                            Home</button>
                        <!-- </div> -->
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>

<ng-container *ngIf="isRemarkModal">
    <div class="modal fade show remarkModal" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="modal-title" id="staticBackdropLabel">
                    </h5>
                    <button type="button" class="btn-close"
                        data-bs-dismiss="modal"
                        (click)="closeRemarkModal()"></button>
                </div>
                <div class="modal-body text">
                    <h5>
                        Benefits of Featured Property:
                    </h5>
                    <ul>
                        <li>Visibility on our homepage</li>
                        <li>Reach to maximum people</li>
                    </ul>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn click"
                        (click)="submitForm(true)">Yes</button>
                    <button type="button" class="btn click"
                        (click)="submitForm(false)">No, Create property
                        only</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div *ngIf="showOthersModal" class="modal-overlay">
    <div class="modal fade show OtherModalName" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1"
        style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">
                        Add Property Type
                    </h5>
                    <button type="button" class="btn-close"
                        data-bs-dismiss="modal" 
                        (click)="closeotherModalName()"></button>
                </div>
                <div class="modal-body text">
                    <div class="row">
                        <div class="col-2">
                            <label for="nameInput"
                                class="form-label">Name:</label>
                        </div>
                        <div class="col-10">
                            <input type="text" class="form-control"
                                id="nameInput">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button"
                        class="btn btn-primary">Submit</button>
                    <button type="button" class="btn btn-primary"
                        data-bs-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="is_terms_modal" class="modal-overlay">
    <div class="modal fade show OtherModalName" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1"
        style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">
                        Confirmation
                    </h5>
                    <button type="button" class="btn-close"
                        (click)="closeTremsModal()"></button>
                </div>
                <div class="modal-body text">
                    <p>I hereby acknowledge that I have read this Agreement and
                        I understand all of it and will be bound by its terms
                        and conditions without any further reservations. I
                        acknowledge further that this Agreement represents the
                        complete and exclusive statement of the pact between
                        DIREKT and me relating to the subject matter of this
                        Agreement.</p>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                        (click)="onAgree()">Submit</button>
                    <button type="button" class="btn btn-primary"
                        (click)="closeTremsModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>